import { _optionalChain } from '@sentry/utils/esm/buildPolyfills';

function isRrwebError(event) {
  if (event.type || !_optionalChain([event, 'access', _ => _.exception, 'optionalAccess', _2 => _2.values, 'optionalAccess', _3 => _3.length])) {
    return false;
  }

  // Check if any exception originates from rrweb
  return event.exception.values.some(exception => {
    if (!_optionalChain([exception, 'access', _4 => _4.stacktrace, 'optionalAccess', _5 => _5.frames, 'optionalAccess', _6 => _6.length])) {
      return false;
    }

    return exception.stacktrace.frames.some(frame => _optionalChain([frame, 'access', _7 => _7.filename, 'optionalAccess', _8 => _8.includes, 'call', _9 => _9('/rrweb/src/')]));
  });
}

export { isRrwebError };
//# sourceMappingURL=isRrwebError.js.map
